
function isLocalStorageSupported () {
    let testKey = "test"
    let storage = window.sessionStorage
    try {
        storage.setItem(testKey, "1")
        storage.removeItem(testKey)
        return true
    } catch (error) {
        return false
    }
}

export default isLocalStorageSupported()

